export const environment = {
  production: false,
  version: "7.13.3",
  apiBaseUrl: "https://app-delivery-service-api-dev-use2.azurewebsites.net/",
  apiPathPrefix: "api/v1",
  hubUrl: "https://main-hub-dev.azurewebsites.net/MenuService",
  appInsights: {
    instrumentationKey: "c182daee-3c50-48a6-a790-9e80a895c2f0",
  },
};
